/* jt-merkkiezer-track.js
   Meet de merkkiezer uit snippets/jt-endura-alternatief.liquid.
   Klik op de Endura-kaart wordt 30 dagen onthouden en komt als
   cart-attribuut Vergelijker mee tot in de bestelling. */
(function () {
  var KEY = 'jt_mk';
  var MAXAGE = 30 * 24 * 60 * 60 * 1000;
  var ATTR = 'Vergelijker';

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    while (r.length > 1 && r.charAt(r.length - 1) === '/') { r = r.slice(0, -1); }
    return r === '/' ? '' : r;
  }

  function save(brand) {
    try { localStorage.setItem(KEY, JSON.stringify({ v: brand, t: Date.now() })); } catch (e) {}
  }

  function load() {
    try {
      var r = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (r && r.v && (Date.now() - r.t) < MAXAGE) return String(r.v);
    } catch (e) {}
    return null;
  }

  function brandOfBlock(card) {
    var blok = card.closest ? card.closest('.jt-brand') : null;
    if (!blok) return '';
    var cur = blok.querySelector('.jt-brand__card--current .jt-brand__name');
    return cur ? String(cur.textContent || '').trim() : '';
  }

  function onCardClick(e) {
    var node = e.target;
    if (node && node.nodeType !== 1) node = node.parentElement;
    var card = node && node.closest ? node.closest('a.jt-brand__card') : null;
    if (!card) return;
    var brand = brandOfBlock(card);
    if (!brand) return;
    save(brand);
    try {
      var u = new URL(card.getAttribute('href'), window.location.origin);
      u.searchParams.set('mk', brand);
      card.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (err) {}
  }

  document.addEventListener('click', onCardClick, true);
  document.addEventListener('auxclick', onCardClick, true);

  var fromUrl = null;
  try { fromUrl = new URLSearchParams(window.location.search).get('mk'); } catch (e) {}
  if (fromUrl) save(fromUrl);

  var brand = fromUrl || load();
  if (!brand) return;
  var label = 'Endura via ' + brand;

  fetch(rootUrl() + '/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (cart) {
      if (!cart) return null;
      if (cart.attributes && cart.attributes[ATTR] === label) return null;
      var payload = { attributes: {} };
      payload.attributes[ATTR] = label;
      return fetch(rootUrl() + '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    })
    .catch(function () {});
})();